import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, Upload, notification, Image, Space, } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { GrUpload } from "react-icons/gr";
import WebAboutRequest from "./webAboutRequest";
import { AiOutlineRight } from "react-icons/ai";
import { updateLanguageServiceSourceFile } from "typescript";
function WebAboutUpdate() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const [submited, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  // ================= FETCH DETAILS =================
  useEffect(() => {
    if (!id) return;

    const fetchDetails = async () => {
      setLoading(true);

      try {
        const res = await WebAboutRequest.getAboutDetail(id);
        const data = res?.data?.data;

        const section = data?.sections?.[0] || {};

        // 🔥 Prefill form
        form.setFieldsValue({
          pageKey: data.pageKey,
          pageTitle: data.pageTitle,
          status: data.status,
          title: section.title,
          content: section.content,
        });

        // Image
        if (section.imageUrl) {
          setImageUrl(section.imageUrl);
          setFileList([
            {
              url: section.imageUrl,
            },
          ]);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [id, form]);

  const update=()=>{
  setSubmit(true);
}
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  // ================= IMAGE =================
 const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

   const handleImageChange = ({ fileList: newFileList }) => setFileList(newFileList);
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
    >
      <GrUpload />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

const imageUpload = (file) => {
  setLoading(true);

  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileName", file.name);

  WebAboutRequest.uploadImage(formData)
    .then((res) => {
      const uploadedUrl = res?.data?.uploadDirectory;

      if (uploadedUrl) {
        setImageUrl(uploadedUrl);
        setFileList([
          {
            uid: "-2",
            name: file.name,
            status: "done",
            url: uploadedUrl,
          },
        ]);

        notification.success({
          message: "Image uploaded successfully",
        });
      }
    })
    .catch((e) => {
      console.error(e);
      notification.error({
        message: "File upload Failed",
      });
      setFileList([]);   // Clear on failure
    })
    .finally(() => {
      setLoading(false);
    });
};


const props = {
  name: "file",
  multiple: false,
  accept: "image/*",
  listType: "picture-card",
  fileList: fileList,
  beforeUpload: (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      notification.error({
        message: "Invalid file type",
        description: "Only image files are allowed (jpg, png, jpeg, webp)",
      });
      return Upload.LIST_IGNORE;
    }

    imageUpload(file);     // Pass file only
    return false;          // Important: stop auto upload
  },
  onRemove: () => {
    setFileList([]);
    setImageUrl("");       // Clear imageUrl when removed
  },
  onChange: handleImageChange,
  onPreview: handlePreview,
};

  // ================= SUBMIT =================
  const onFinish = (values) => {
    if (!imageUrl) {
      notification.error({ message: "Upload image" });
      return;
    }

    const payload = {
      id,
      pageKey: values.pageKey,
      pageTitle: values.pageTitle,
      status: values.status,

      sections: [
        {
          sectionKey: "intro",
          type: "content_with_image",
          orderBy: 1,
          title: values.title,
          content: values.content  || [],
          imageUrl: imageUrl,
          imageAlt: "About Image",
        },
      ],
    };

    console.log("UPDATE PAYLOAD:", payload);

    setLoading(true);

    WebAboutRequest
      .postUpdateAbout(payload)
      .then((res) => {
        if (res.status === 200) {
          notification.success({
            message: "Updated successfully",
          });
          navigate(-1);
        }
      })
      .catch(() => {
        notification.error({
          message: "Update failed",
        });
      })
      .finally(() => setLoading(false));
  };

  return (
     <div className="Create-Category">
        <Space>
          <Button onClick={() => navigate(-1)}>
            <ArrowLeftOutlined />
          </Button>
        </Space>
  
        <h3>Update  About Us Page content</h3>
  
        <Form layout="vertical" form={form} onFinish={onFinish}>
          {/* PAGE FIELDS */}
          <div className="subscription">
  
            <Form.Item
              label="Page Key"
              name="pageKey"
              initialValue="about-us"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter page key" },
                {
                  pattern: /^[a-z0-9-]+$/,
                  message: "Page key can contain only lowercase letters, numbers, and hyphens",
                },
              ]}
            >
              <Input size="large" placeholder="Enter page key" />
            </Form.Item>
  
            <Form.Item
              label="Page Title"
              name="pageTitle"
              className="subscription-plan"
              rules={[{ required: true }]}
            >
               <Input size="large" placeholder="Enter page title e.g about-us" />
            </Form.Item>
          </div>
  
          <div className="subscription">
            <Form.Item
              label="Status"
              name="status"
              className="subscription-plan"
              rules={[{ required: true }]}
              
            >
              <Select
                options={[
                  { label: "Active", value: 1 },
                  { label: "Inactive", value: 0 },
                ]}
                />
            </Form.Item>
  
            {/* SECTION TITLE */}
            <Form.Item
              label="Section Title"
              name="title"
              className="subscription-plan"
              rules={[{ required: true }]}
            >
               <Input size="large" placeholder="Enter section title" />
            </Form.Item>
          </div>
  
  
          {/* CONTENT */}
         
          <Form.List name="content">
            {(fields, { add, remove }) => (
              <>
                <h6>Content</h6>
  
                {fields.map(({ key, name }) => (
                  <div key={key} className="d-flex  gap-5 items-center w-full">
                    <Form.Item
                      name={[name, "type"]}
                      rules={[{ required: true }]}
                      className="subscription-plan"
                    >
                      <Select
                        placeholder="Type"
                        size="large"
                        options={[
                          { label: "Heading", value: "heading" },
                          { label: "Paragraph", value: "paragraph" },
                        ]}
                      />
                    </Form.Item>
  
                    <Form.Item
                      name={[name, "value"]}
                      rules={[{ required: true }]}
                      className="subscription-plan"
                    >
                      <Input.TextArea placeholder="Enter text"  size="large"/>
                    </Form.Item>
                    <div className="d-flex gap-4  mb-5">
                      <Button danger onClick={() => remove(name)}>
                        Delete
                      </Button>
                     
                    </div>
  
                  </div>
                ))}
                 <Button onClick={() => add()} type="dashed" className="mb-3">
                        Add Content
                      </Button>
  
  
              </>
            )}
          </Form.List>
  
  
         
  
          {/* STATS */}
          <Form.List name="stats">
            {(fields, { add, remove }) => (
              <>
                <h6>Stats</h6>
                  {fields.map(({ key, name }) => (
                    <div key={key} className="d-flex items-center gap-5">
                      
                      <Form.Item
                        name={[name, "label"]}
                        rules={[{ required: true }]}
                        className="subscription-plan"
                      >
                       <Input size="large" placeholder="Enter Label" />
                      </Form.Item>
  
                      <Form.Item
                        name={[name, "value"]}
                        rules={[{ required: true }]}
                        className="subscription-plan"
                      >
                         <Input size="large" placeholder="Enter Value" />
                      </Form.Item>
  
                      <Button danger onClick={() => remove(name)}>
                        Delete
                      </Button>
                    </div>
                  ))}
  
  
                  <Button onClick={() => add()} type="dashed" className="mb-3">
                    Add Stat
                  </Button>
               
              </>
            )}
          </Form.List>
  
           {/* IMAGE */}
          <Form.Item label="Upload Image" required>
            <Upload
              {...props}
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              onChange={handleImageChange}
            >
              {fileList.length >= 1 ? null : (
                <div>
                  <GrUpload />
                  <div>Upload</div>
                </div>
              )}
            </Upload>
  
            {previewImage && (
              <Image
                style={{ display: "none" }}
                preview={{
                  visible: previewOpen,
                  onVisibleChange: setPreviewOpen,
                }}
                src={previewImage}
              />
            )}
          </Form.Item>
  
          {/* SUBMIT */}
          <div className="bottom-button">
            <div style={{ padding: "10px" }}>
              <Button type="primary" htmlType="submit" loading={loading} onClick={update}>
                Save & Proceed
                <span>
                  <AiOutlineRight />
                </span>
              </Button>
            </div>
          </div>
        </Form>
      </div>
  );
}

export default WebAboutUpdate;